import { EntityRoutes } from 'routes/constants';
import { TabKeys } from 'UI/constants/entityTypes';
import { KEYWORDS_COLUMN } from 'UI/constants/sharedColumns';

export const CompanyColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      print: false,
      display: 'excluded'
    }
  },
  {
    name: 'type',
    label: 'Status',
    options: {
      display: true,
      sort: false,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-company-type'
        }
      }
    }
  },
  {
    name: 'name',
    label: 'Name',
    options: {
      display: true,
      sort: false,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: `${EntityRoutes.CompanyProfile}?tab=${TabKeys.HiringAuthorities}`,
          idKey: 'id',
          textKey: 'name'
        }
      }
    }
  },
  {
    name: 'specialty.industry.title',
    label: 'Industry',
    options: {
      sort: false,
      display: true,
      renderer: 'default'
    }
  },
  {
    name: 'specialty.title',
    label: 'Specialty',
    options: {
      sort: false,
      display: true,
      renderer: 'default'
    }
  },
  {
    name: 'city.title',
    label: 'City',
    options: {
      sort: false,
      display: true,
      renderer: 'default'
    }
  },
  {
    name: 'city.state.title',
    label: 'State',
    options: {
      sort: false,
      display: true,
      renderer: 'default'
    }
  },
  {
    name: 'address',
    label: 'Address',
    options: {
      sort: false,
      display: true,
      renderer: 'default'
    }
  },
  {
    name: 'lastActivityLog.date',
    label: 'Last Activity on',
    options: {
      renderer: 'date',
      sort: true
    }
  },
  {
    name: 'lastActivityLog.recruiter',
    label: 'Last Activity by',
    options: {
      renderer: 'default',
      sort: false
    }
  },
  {
    name: 'lastActivityLog.title',
    label: 'Last Activity',
    options: {
      renderer: 'default',
      sort: false
    }
  },
  {
    name: 'last_payment',
    label: 'Last Payment',
    options: {
      renderer: 'date',
      sort: false
    }
  },
  {
    ...KEYWORDS_COLUMN,
    name: 'keywordTags'
  }
];

export const CompaniesVirtualProps = [
  {
    propName: 'name',
    attributes: ['name', 'id']
  }
];
